export const darkThemePaths = [
  '/',
  '/blackfriday',
  '/blackfridayfaq',
  '/blackfriday/[username]',
  '/blackfriday/trivia',
  '/blackfriday/trivia/[gameId]',
  '/blackfriday/trivia/[gameId]/lobby',
  '/brand/[slug]',
  '/manifesto',
  '/gift-cards/[uuid]',
  '/ja-jp/blackfriday/trivia/[gameId]',
  '/ja-jp/blackfriday/trivia/[gameId]/lobby',
  '/zh-cn/blackfriday/trivia/[gameId]',
  '/zh-cn/blackfriday/trivia/[gameId]/lobby',
];
